import React from 'react';

import {Field} from 'react-final-form';
import TextField from '@mui/material/TextField';
//import TextFieldWrapper from './redux-form/TextFieldWrapper'
//import TextField from './Field/TextField'

import {withDcxFormContext} from './DcxForm';

const reduceControl = (formControlContext) => {
    const {readOnly} = formControlContext;
    return {readOnly}
}

const reduceInput = (formControlContext, other) => {
    const {variant} = formControlContext;
    if (other.Input) {
        let reduced = {
            Input: Object.assign({variant}, {...other.Input})
        }
        return reduced;
    }
    return {Input: {variant}}
}

const DcxFormField = ({Component, formControlContext, name, ...rest}) => (
    <Field
       name={name}
    >
      {props => {
          const d = 9;
          if(d > 0){
            return <>
                <TextField
                    name={props.input.name}
                    value={props.input.value}
                    onChange={props.input.onChange}
                  />
            </>
          }

      return (
          <Component
            name={name}
            {...reduceControl(formControlContext, rest)}
            {...reduceInput(formControlContext, rest)}
            {...rest}
          />
      )}}
    </Field>
)
export default withDcxFormContext(DcxFormField)